var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpacebugsImgBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 344,
    height: 447,
    viewBox: "0 0 344 447",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_714_12397)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 447,
    rx: 56,
    fill: "url(#paint0_radial_714_12397)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M405.504 -2379L172 290L-61.5037 -2379H405.504ZM-960.073 -2138.19L172 290L-521.422 -2297.89L-960.073 -2138.19ZM-1722.46 -1604.46L172 290L-1364.71 -1904.68L-1722.46 -1604.46ZM-2256.19 -842.073L172 290L-2022.68 -1246.71L-2256.19 -842.073ZM-2497 56.7161L172 290L-2415.89 -403.422L-2497 56.7161ZM-2415.89 983.643L172 290L-2497 523.504L-2415.89 983.643ZM-2022.68 1826.93L172 290L-2256.19 1422.07L-2022.68 1826.93ZM-1364.71 2484.68L172 290L-1722.46 2184.46L-1364.71 2484.68ZM-521.422 2877.94L172 290L-960.073 2718.19L-521.422 2877.94ZM405.504 2959L172 290L-61.5037 2959H405.504ZM1304.07 2718.19L172 290L865.423 2877.94L1304.07 2718.19ZM2066.24 2184.46L172 290L1708.71 2484.68L2066.24 2184.46ZM2600.19 1422.07L172 290L2366.68 1826.71L2600.19 1422.07ZM2841 523.284L172 290L2759.94 983.423L2841 523.284ZM2759.94 -403.422L172 290L2841 56.4963L2759.94 -403.422ZM2366.68 -1246.71L172 290L2600.19 -842.073L2366.68 -1246.71ZM1708.71 -1904.68L172 290L2066.46 -1604.46L1708.71 -1904.68ZM865.423 -2297.89L172 290L1304.07 -2138.19L865.423 -2297.89Z",
    fill: "url(#paint1_radial_714_12397)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M106.982 76.168C105.75 76.168 104.646 75.968 103.67 75.568C102.694 75.168 101.91 74.576 101.318 73.792C100.742 73.008 100.438 72.064 100.406 70.96H104.774C104.838 71.584 105.054 72.064 105.422 72.4C105.79 72.72 106.27 72.88 106.862 72.88C107.47 72.88 107.95 72.744 108.302 72.472C108.654 72.184 108.83 71.792 108.83 71.296C108.83 70.88 108.686 70.536 108.398 70.264C108.126 69.992 107.782 69.768 107.366 69.592C106.966 69.416 106.39 69.216 105.638 68.992C104.55 68.656 103.662 68.32 102.974 67.984C102.286 67.648 101.694 67.152 101.198 66.496C100.702 65.84 100.454 64.984 100.454 63.928C100.454 62.36 101.022 61.136 102.158 60.256C103.294 59.36 104.774 58.912 106.598 58.912C108.454 58.912 109.95 59.36 111.086 60.256C112.222 61.136 112.83 62.368 112.91 63.952H108.47C108.438 63.408 108.238 62.984 107.87 62.68C107.502 62.36 107.03 62.2 106.454 62.2C105.958 62.2 105.558 62.336 105.254 62.608C104.95 62.864 104.798 63.24 104.798 63.736C104.798 64.28 105.054 64.704 105.566 65.008C106.078 65.312 106.878 65.64 107.966 65.992C109.054 66.36 109.934 66.712 110.606 67.048C111.294 67.384 111.886 67.872 112.382 68.512C112.878 69.152 113.126 69.976 113.126 70.984C113.126 71.944 112.878 72.816 112.382 73.6C111.902 74.384 111.198 75.008 110.27 75.472C109.342 75.936 108.246 76.168 106.982 76.168ZM119.756 64.504C120.156 63.88 120.708 63.376 121.412 62.992C122.116 62.608 122.94 62.416 123.884 62.416C124.988 62.416 125.988 62.696 126.884 63.256C127.78 63.816 128.484 64.616 128.996 65.656C129.524 66.696 129.788 67.904 129.788 69.28C129.788 70.656 129.524 71.872 128.996 72.928C128.484 73.968 127.78 74.776 126.884 75.352C125.988 75.912 124.988 76.192 123.884 76.192C122.956 76.192 122.132 76 121.412 75.616C120.708 75.232 120.156 74.736 119.756 74.128V82.384H115.652V62.608H119.756V64.504ZM125.612 69.28C125.612 68.256 125.324 67.456 124.748 66.88C124.188 66.288 123.492 65.992 122.66 65.992C121.844 65.992 121.148 66.288 120.572 66.88C120.012 67.472 119.732 68.28 119.732 69.304C119.732 70.328 120.012 71.136 120.572 71.728C121.148 72.32 121.844 72.616 122.66 72.616C123.476 72.616 124.172 72.32 124.748 71.728C125.324 71.12 125.612 70.304 125.612 69.28ZM131.125 69.28C131.125 67.904 131.381 66.696 131.893 65.656C132.421 64.616 133.133 63.816 134.029 63.256C134.925 62.696 135.925 62.416 137.029 62.416C137.973 62.416 138.797 62.608 139.501 62.992C140.221 63.376 140.773 63.88 141.157 64.504V62.608H145.261V76H141.157V74.104C140.757 74.728 140.197 75.232 139.477 75.616C138.773 76 137.949 76.192 137.005 76.192C135.917 76.192 134.925 75.912 134.029 75.352C133.133 74.776 132.421 73.968 131.893 72.928C131.381 71.872 131.125 70.656 131.125 69.28ZM141.157 69.304C141.157 68.28 140.869 67.472 140.293 66.88C139.733 66.288 139.045 65.992 138.229 65.992C137.413 65.992 136.717 66.288 136.141 66.88C135.581 67.456 135.301 68.256 135.301 69.28C135.301 70.304 135.581 71.12 136.141 71.728C136.717 72.32 137.413 72.616 138.229 72.616C139.045 72.616 139.733 72.32 140.293 71.728C140.869 71.136 141.157 70.328 141.157 69.304ZM147.414 69.304C147.414 67.912 147.694 66.696 148.254 65.656C148.83 64.616 149.622 63.816 150.63 63.256C151.654 62.696 152.822 62.416 154.134 62.416C155.814 62.416 157.214 62.856 158.334 63.736C159.47 64.616 160.214 65.856 160.566 67.456H156.198C155.83 66.432 155.118 65.92 154.062 65.92C153.31 65.92 152.71 66.216 152.262 66.808C151.814 67.384 151.59 68.216 151.59 69.304C151.59 70.392 151.814 71.232 152.262 71.824C152.71 72.4 153.31 72.688 154.062 72.688C155.118 72.688 155.83 72.176 156.198 71.152H160.566C160.214 72.72 159.47 73.952 158.334 74.848C157.198 75.744 155.798 76.192 154.134 76.192C152.822 76.192 151.654 75.912 150.63 75.352C149.622 74.792 148.83 73.992 148.254 72.952C147.694 71.912 147.414 70.696 147.414 69.304ZM175.385 69.088C175.385 69.472 175.361 69.872 175.313 70.288H166.025C166.089 71.12 166.353 71.76 166.817 72.208C167.297 72.64 167.881 72.856 168.569 72.856C169.593 72.856 170.305 72.424 170.705 71.56H175.073C174.849 72.44 174.441 73.232 173.849 73.936C173.273 74.64 172.545 75.192 171.665 75.592C170.785 75.992 169.801 76.192 168.713 76.192C167.401 76.192 166.233 75.912 165.209 75.352C164.185 74.792 163.385 73.992 162.809 72.952C162.233 71.912 161.945 70.696 161.945 69.304C161.945 67.912 162.225 66.696 162.785 65.656C163.361 64.616 164.161 63.816 165.185 63.256C166.209 62.696 167.385 62.416 168.713 62.416C170.009 62.416 171.161 62.688 172.169 63.232C173.177 63.776 173.961 64.552 174.521 65.56C175.097 66.568 175.385 67.744 175.385 69.088ZM171.185 68.008C171.185 67.304 170.945 66.744 170.465 66.328C169.985 65.912 169.385 65.704 168.665 65.704C167.977 65.704 167.393 65.904 166.913 66.304C166.449 66.704 166.161 67.272 166.049 68.008H171.185ZM186.287 67.384C186.895 67.48 187.447 67.728 187.943 68.128C188.455 68.528 188.855 69.024 189.143 69.616C189.447 70.208 189.599 70.84 189.599 71.512C189.599 72.36 189.383 73.128 188.951 73.816C188.519 74.488 187.887 75.024 187.055 75.424C186.239 75.808 185.271 76 184.151 76H177.911V59.272H183.911C185.047 59.272 186.015 59.464 186.815 59.848C187.615 60.216 188.215 60.72 188.615 61.36C189.015 62 189.215 62.72 189.215 63.52C189.215 64.512 188.943 65.336 188.398 65.992C187.871 66.632 187.167 67.096 186.287 67.384ZM180.095 66.496H183.767C184.791 66.496 185.583 66.256 186.143 65.776C186.703 65.296 186.983 64.632 186.983 63.784C186.983 62.936 186.703 62.272 186.143 61.792C185.583 61.312 184.775 61.072 183.719 61.072H180.095V66.496ZM183.959 74.2C185.047 74.2 185.895 73.944 186.503 73.432C187.111 72.92 187.415 72.208 187.415 71.296C187.415 70.368 187.095 69.64 186.455 69.112C185.815 68.568 184.959 68.296 183.887 68.296H180.095V74.2H183.959ZM204.293 62.848V76H202.109V74.056C201.693 74.728 201.109 75.256 200.357 75.64C199.621 76.008 198.805 76.192 197.909 76.192C196.885 76.192 195.965 75.984 195.149 75.568C194.333 75.136 193.685 74.496 193.205 73.648C192.741 72.8 192.509 71.768 192.509 70.552V62.848H194.669V70.264C194.669 71.56 194.997 72.56 195.653 73.264C196.309 73.952 197.205 74.296 198.341 74.296C199.509 74.296 200.429 73.936 201.101 73.216C201.773 72.496 202.109 71.448 202.109 70.072V62.848H204.293ZM207.165 69.4C207.165 68.04 207.437 66.856 207.981 65.848C208.525 64.824 209.277 64.032 210.237 63.472C211.213 62.912 212.325 62.632 213.573 62.632C215.189 62.632 216.517 63.024 217.557 63.808C218.613 64.592 219.309 65.68 219.645 67.072H217.293C217.069 66.272 216.629 65.64 215.973 65.176C215.333 64.712 214.533 64.48 213.573 64.48C212.325 64.48 211.317 64.912 210.549 65.776C209.781 66.624 209.397 67.832 209.397 69.4C209.397 70.984 209.781 72.208 210.549 73.072C211.317 73.936 212.325 74.368 213.573 74.368C214.533 74.368 215.333 74.144 215.973 73.696C216.613 73.248 217.053 72.608 217.293 71.776H219.645C219.293 73.12 218.589 74.2 217.533 75.016C216.477 75.816 215.157 76.216 213.573 76.216C212.325 76.216 211.213 75.936 210.237 75.376C209.277 74.816 208.525 74.024 207.981 73C207.437 71.976 207.165 70.776 207.165 69.4ZM229.903 76L224.743 70.192V76H222.559V58.24H224.743V68.68L229.807 62.848H232.855L226.663 69.4L232.879 76H229.903ZM239.567 76.216C238.559 76.216 237.655 76.048 236.855 75.712C236.055 75.36 235.423 74.88 234.959 74.272C234.495 73.648 234.239 72.936 234.191 72.136H236.447C236.511 72.792 236.815 73.328 237.359 73.744C237.919 74.16 238.647 74.368 239.543 74.368C240.375 74.368 241.031 74.184 241.511 73.816C241.991 73.448 242.231 72.984 242.231 72.424C242.231 71.848 241.975 71.424 241.463 71.152C240.951 70.864 240.159 70.584 239.087 70.312C238.111 70.056 237.311 69.8 236.687 69.544C236.079 69.272 235.551 68.88 235.103 68.368C234.671 67.84 234.455 67.152 234.455 66.304C234.455 65.632 234.655 65.016 235.055 64.456C235.455 63.896 236.023 63.456 236.759 63.136C237.495 62.8 238.335 62.632 239.279 62.632C240.735 62.632 241.911 63 242.807 63.736C243.703 64.472 244.183 65.48 244.247 66.76H242.063C242.015 66.072 241.735 65.52 241.223 65.104C240.727 64.688 240.055 64.48 239.207 64.48C238.423 64.48 237.799 64.648 237.335 64.984C236.871 65.32 236.639 65.76 236.639 66.304C236.639 66.736 236.775 67.096 237.047 67.384C237.335 67.656 237.687 67.88 238.103 68.056C238.535 68.216 239.127 68.4 239.879 68.608C240.823 68.864 241.591 69.12 242.183 69.376C242.775 69.616 243.279 69.984 243.695 70.48C244.127 70.976 244.351 71.624 244.367 72.424C244.367 73.144 244.167 73.792 243.767 74.368C243.367 74.944 242.799 75.4 242.063 75.736C241.343 76.056 240.511 76.216 239.567 76.216Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    filter: "url(#filter0_f_714_12397)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 165.314,
    cy: 293.473,
    rx: 116.025,
    ry: 112.143,
    fill: "#0F0339"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 163.816,
    cy: 289.817,
    r: 98.4325,
    transform: "rotate(-53.0944 163.816 289.817)",
    fill: "url(#paint2_radial_714_12397)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_714_12397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 163.817,
    cy: 289.818,
    r: 74.9073,
    transform: "rotate(120 163.817 289.818)",
    fill: "url(#paint3_radial_714_12397)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_714_12397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 163.797,
    cy: 289.799,
    r: 71.3687,
    transform: "rotate(-180 163.797 289.799)",
    fill: "url(#paint4_radial_714_12397)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_714_12397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M161.867 247.037C162.555 245.407 164.865 245.407 165.553 247.037L177.362 274.991C177.565 275.471 177.947 275.853 178.427 276.056L206.381 287.865C208.011 288.553 208.011 290.863 206.381 291.551L178.427 303.36C177.947 303.563 177.565 303.945 177.362 304.425L165.553 332.379C164.865 334.009 162.555 334.009 161.867 332.379L150.058 304.425C149.855 303.945 149.473 303.563 148.993 303.36L121.039 291.551C119.409 290.863 119.409 288.553 121.039 287.865L148.993 276.056C149.473 275.853 149.855 275.471 150.058 274.991L161.867 247.037Z",
    fill: "url(#paint5_linear_714_12397)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M191.457 254.356C191.586 254.008 192.078 254.008 192.207 254.356L193.733 258.478C193.773 258.588 193.859 258.674 193.969 258.715L198.091 260.24C198.439 260.369 198.439 260.862 198.091 260.99L193.969 262.516C193.859 262.556 193.773 262.643 193.733 262.752L192.207 266.874C192.078 267.223 191.586 267.223 191.457 266.874L189.931 262.752C189.891 262.643 189.804 262.556 189.695 262.516L185.573 260.99C185.224 260.862 185.224 260.369 185.573 260.24L189.695 258.715C189.804 258.674 189.891 258.588 189.931 258.478L191.457 254.356Z",
    fill: "url(#paint6_linear_714_12397)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 247.296,
    cy: 336.674,
    r: 50.6717,
    transform: "rotate(126.906 247.296 336.674)",
    fill: "url(#paint7_radial_714_12397)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_i_714_12397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 247.301,
    cy: 336.675,
    r: 38.5613,
    transform: "rotate(-60 247.301 336.675)",
    fill: "url(#paint8_radial_714_12397)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_i_714_12397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 247.304,
    cy: 336.685,
    r: 36.7396,
    fill: "url(#paint9_radial_714_12397)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_714_12397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M248.285 358.735C247.936 359.56 246.767 359.56 246.419 358.735L240.321 344.3C240.219 344.057 240.025 343.864 239.782 343.762L225.348 337.664C224.523 337.315 224.523 336.146 225.348 335.798L239.782 329.7C240.025 329.597 240.219 329.404 240.321 329.161L246.419 314.727C246.767 313.902 247.936 313.902 248.285 314.727L254.383 329.161C254.485 329.404 254.679 329.597 254.921 329.7L269.356 335.798C270.181 336.146 270.181 337.315 269.356 337.664L254.921 343.762C254.679 343.864 254.485 344.057 254.383 344.3L248.285 358.735Z",
    fill: "url(#paint10_linear_714_12397)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M233.063 354.94C232.998 355.116 232.748 355.116 232.683 354.94L231.894 352.808C231.874 352.752 231.83 352.708 231.774 352.688L229.642 351.899C229.466 351.834 229.466 351.584 229.642 351.519L231.774 350.73C231.83 350.709 231.874 350.666 231.894 350.61L232.683 348.478C232.748 348.302 232.998 348.302 233.063 348.478L233.852 350.61C233.872 350.666 233.916 350.709 233.972 350.73L236.104 351.519C236.28 351.584 236.28 351.834 236.104 351.899L233.972 352.688C233.916 352.708 233.872 352.752 233.852 352.808L233.063 354.94Z",
    fill: "url(#paint11_linear_714_12397)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.635,
    cy: 355.146,
    r: 34.2659,
    transform: "rotate(-53.0944 109.635 355.146)",
    fill: "url(#paint12_radial_714_12397)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_i_714_12397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109.639,
    cy: 355.146,
    r: 26.0764,
    transform: "rotate(120 109.639 355.146)",
    fill: "url(#paint13_radial_714_12397)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter8_i_714_12397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 109.628,
    cy: 355.14,
    r: 24.8446,
    transform: "rotate(-180 109.628 355.14)",
    fill: "url(#paint14_radial_714_12397)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter9_d_714_12397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.963 340.228C109.199 339.67 109.989 339.67 110.225 340.228L114.348 349.989C114.418 350.153 114.549 350.284 114.713 350.353L124.474 354.477C125.032 354.712 125.032 355.503 124.474 355.739L114.713 359.862C114.549 359.932 114.418 360.062 114.348 360.227L110.225 369.988C109.989 370.546 109.199 370.546 108.963 369.988L104.84 360.227C104.77 360.062 104.64 359.932 104.475 359.862L94.7141 355.739C94.1563 355.503 94.1563 354.712 94.7141 354.477L104.475 350.353C104.64 350.284 104.77 350.153 104.84 349.989L108.963 340.228Z",
    fill: "url(#paint15_linear_714_12397)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M119.261 342.794C119.305 342.675 119.474 342.675 119.518 342.794L120.051 344.236C120.065 344.274 120.095 344.303 120.132 344.317L121.574 344.851C121.693 344.895 121.693 345.064 121.574 345.108L120.132 345.641C120.095 345.655 120.065 345.685 120.051 345.722L119.518 347.164C119.474 347.283 119.305 347.283 119.261 347.164L118.727 345.722C118.714 345.685 118.684 345.655 118.646 345.641L117.205 345.108C117.085 345.064 117.085 344.895 117.205 344.851L118.646 344.317C118.684 344.303 118.714 344.274 118.727 344.236L119.261 342.794Z",
    fill: "url(#paint16_linear_714_12397)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 145.289,
    cy: 367.675,
    r: 25.3172,
    transform: "rotate(-53.0944 145.289 367.675)",
    fill: "url(#paint17_radial_714_12397)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter10_i_714_12397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145.291,
    cy: 367.675,
    r: 19.2665,
    transform: "rotate(120 145.291 367.675)",
    fill: "url(#paint18_radial_714_12397)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter11_i_714_12397)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 145.282,
    cy: 367.671,
    r: 18.3563,
    transform: "rotate(-180 145.282 367.671)",
    fill: "url(#paint19_radial_714_12397)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter12_d_714_12397)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.623 357.044C144.858 356.486 145.649 356.486 145.885 357.044L148.738 363.799C148.808 363.964 148.938 364.094 149.103 364.164L155.858 367.017C156.415 367.253 156.415 368.043 155.858 368.279L149.103 371.133C148.938 371.202 148.808 371.333 148.738 371.497L145.885 378.252C145.649 378.81 144.858 378.81 144.623 378.252L141.769 371.497C141.7 371.333 141.569 371.202 141.405 371.133L134.65 368.279C134.092 368.043 134.092 367.253 134.65 367.017L141.405 364.164C141.569 364.094 141.7 363.964 141.769 363.799L144.623 357.044Z",
    fill: "url(#paint20_linear_714_12397)",
    shapeRendering: "crispEdges"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M152.367 358.64C152.411 358.521 152.58 358.521 152.624 358.64L152.979 359.599C152.993 359.637 153.023 359.666 153.06 359.68L154.019 360.035C154.139 360.079 154.139 360.248 154.019 360.292L153.06 360.647C153.023 360.661 152.993 360.691 152.979 360.728L152.624 361.687C152.58 361.807 152.411 361.807 152.367 361.687L152.012 360.728C151.998 360.691 151.969 360.661 151.931 360.647L150.972 360.292C150.853 360.248 150.853 360.079 150.972 360.035L151.931 359.68C151.969 359.666 151.998 359.637 152.012 359.599L152.367 358.64Z",
    fill: "url(#paint21_linear_714_12397)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_714_12397",
    x: -23.1726,
    y: 108.868,
    width: 376.974,
    height: 369.21,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 36.2308,
    result: "effect1_foregroundBlur_714_12397"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_714_12397",
    x: 88.8965,
    y: 214.898,
    width: 149.84,
    height: 149.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.6008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_12397"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_714_12397",
    x: 92.4277,
    y: 218.43,
    width: 142.738,
    height: 142.738,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.6008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_12397"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_714_12397",
    x: 114.414,
    y: 241.212,
    width: 98.5925,
    height: 98.5925,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.800401
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.70135
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.420347 0 0 0 0 0.271927 0 0 0 0 0.945833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_12397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_12397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_i_714_12397",
    x: 208.732,
    y: 298.107,
    width: 77.1367,
    height: 77.1348,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.810198
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_12397"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_i_714_12397",
    x: 210.564,
    y: 299.945,
    width: 73.4785,
    height: 73.4785,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.810198
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_12397"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_714_12397",
    x: 221.994,
    y: 311.778,
    width: 50.7149,
    height: 50.7149,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.405099
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.36721
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.420347 0 0 0 0 0.271927 0 0 0 0 0.945833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_12397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_12397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_i_714_12397",
    x: 83.5586,
    y: 329.064,
    width: 52.1602,
    height: 52.1621,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.547883
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_12397"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_i_714_12397",
    x: 84.7832,
    y: 330.295,
    width: 49.6895,
    height: 49.6895,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.547883
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_12397"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_d_714_12397",
    x: 92.4458,
    y: 338.233,
    width: 34.2959,
    height: 34.2959,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.273941
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.924552
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.420347 0 0 0 0 0.271927 0 0 0 0 0.945833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_12397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_12397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_i_714_12397",
    x: 126.021,
    y: 348.406,
    width: 38.5391,
    height: 38.5391,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.547883
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_12397"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_i_714_12397",
    x: 126.926,
    y: 349.314,
    width: 36.7129,
    height: 36.7129,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.547883
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_714_12397"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_d_714_12397",
    x: 132.381,
    y: 355.05,
    width: 25.7431,
    height: 25.7431,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.273941
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.924552
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.420347 0 0 0 0 0.271927 0 0 0 0 0.945833 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_714_12397"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_714_12397",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.3058 24.2814) rotate(50.2456) scale(511.803 2819.4)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.679653,
    stopColor: "#1B0664"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#120051"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(172 290) rotate(45) scale(328.097)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(186.832 201.032) rotate(101.579) scale(186.179)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.333 222.253) rotate(101.579) scale(141.682)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(180.485 225.425) rotate(101.579) scale(134.989)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_714_12397",
    x1: 163.71,
    y1: 242.674,
    x2: 163.71,
    y2: 336.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_714_12397",
    x1: 191.832,
    y1: 253.342,
    x2: 191.832,
    y2: 267.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B29DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(259.144 290.969) rotate(101.579) scale(95.8423)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(256.317 301.893) rotate(101.579) scale(72.9362)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(255.895 303.546) rotate(101.579) scale(69.4906)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_714_12397",
    x1: 247.352,
    y1: 360.943,
    x2: 247.352,
    y2: 312.518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_714_12397",
    x1: 232.873,
    y1: 355.453,
    x2: 232.873,
    y2: 347.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B29DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(117.647 324.238) rotate(101.579) scale(64.8118)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.736 331.625) rotate(101.579) scale(49.3219)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(115.438 332.73) rotate(101.579) scale(46.9919)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_714_12397",
    x1: 109.594,
    y1: 338.734,
    x2: 109.594,
    y2: 371.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_714_12397",
    x1: 119.389,
    y1: 342.447,
    x2: 119.389,
    y2: 347.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B29DFF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(151.209 344.84) rotate(101.579) scale(47.8859)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.796 350.297) rotate(101.579) scale(36.4413)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_714_12397",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(149.575 351.114) rotate(101.579) scale(34.7198)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B49EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.565625,
    stopColor: "#6F4AF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.815625,
    stopColor: "#4623C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2D118E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_714_12397",
    x1: 145.254,
    y1: 355.551,
    x2: 145.254,
    y2: 379.746,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.22
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_714_12397",
    x1: 152.496,
    y1: 358.293,
    x2: 152.496,
    y2: 362.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7B8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B29DFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_714_12397"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 344,
    height: 447,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpacebugsImgBox);
export default __webpack_public_path__ + "static/media/spacebugs-img-box.88cd322f7ef512d99937f5bcdb0249ad.svg";
export { ForwardRef as ReactComponent };